import { ModelType } from '../../common/enums.js';
import { AnalyticsListNames } from '../../common/utils/analyticsUtils';
import type { CampaignAssociation } from '../../generated/api/campaignAssociation.js';
import type { Offer } from '../../generated/api/offer.js';
import type { OnlineModel } from '../../generated/api/onlineModel.js';
import type { SubCardProps } from '../SubscriptionCard/SubscriptionCard.js';

export type SubCardWithAnalyticsV4Props = SubCardProps & {
  offer: Offer;
  onlineModel: OnlineModel;
  voucher?: string;
  campaignAssociation?: CampaignAssociation;
};
export type SubCardWithImpressionProps = SubCardWithAnalyticsV4Props & {
  analyticsListName: string;
  listPosition: number;
  productName: string;
};

export type AnalyticsPrices = {
  oneTimePrice?: number;
  monthlyPrice?: number;
};

export const getAnalyticsListName = (onlineModelType: ModelType) => {
  if (onlineModelType === ModelType.MobileBroadband) {
    return AnalyticsListNames.MBB_YRITYSDATA_LIST_NAME;
  } else if (onlineModelType === ModelType.MobileM2M) {
    return AnalyticsListNames.LAITE_NETTI_LIST_NAME;
  }

  return AnalyticsListNames.VOICE_LIST_NAME;
};

// We can fire the impression only when we have an onlineModel & offer.
export const isSubCardWithImpression = (
  subscription: SubCardProps | SubCardWithImpressionProps
): subscription is SubCardWithImpressionProps => !!(subscription as SubCardWithImpressionProps).offer;
